import { ConfigProvider, Pagination } from "antd";
import React, { useEffect, useState } from 'react';
import GroupItemComponent from "../component/GroupItemComponent";
import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import AddGroupModal from "../component/modals/AddGroupModal";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import QrGroupModal from "../component/modals/QrModal";
import ViewGroupModal from "../component/modals/ViewGroupModal";
import { constants, sortingOptions1 } from "../constant/constants";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import CustomLoader from "../component/menu/CustomLoader";
import DataNotFound from "../component/common/DataNotFound";
import TableHeaderComponent from "../component/TableHeaderComponent";

function Group() {
    const {user, restaurantSlug, networkCall, setNetworkCall, showNotification} = useUserStore();
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
    const [confirmationMessage, setConfirmationMessage] = useState("")
    const [selectedGroup, setSelectedGroup] = useState({})
    const [records, setRecords] = useState([])
    const [searchText, setSearchText] = useState("")
    const [firstTime, setFirstTime] = useState(true)
    const [totalGroup, setTotalGroup] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [viewGroupModal, setViewGroupModal] = useState(false)
    const [qrGroupModal, setQrGroupModal] = useState(false)
    const [filter, setFilter] = useState({
        searchText: "",
        sortBy: "",
        restaurantSlug: "",
        page: currentPage,
        perPage: perPage
    })
    const onClickViewGroupModal = (response) => {
        setViewGroupModal(false)
    }
    const onClickQrGroupModal = () => {
        setQrGroupModal(false)
    }
    const onClickSaveButtonInModal = (response) => {
        // Create a plain object for group data
        const newGroupData = {
            groupId: response.param.groupId ?? "",
            name: response.param.group,
            restaurantIds: response.param.selectedRestaurants.map((restaurant) => restaurant.value),
        };
        addGroup(newGroupData);
        setViewGroupModal(false);
    };
    
    const onClickCancelButtonInModal = () => {
        setIsModalOpen(false)
    }
    const onClickAddButton = (value) => {
        setIsModalOpen(value)
        setSearchText("")
    }
    const onSearchText = (value) => {
        setFilter({...filter, searchText: value, page: 1})
    }
    const onSortRecord = (value) => {
        setFilter({...filter, sortBy: value})
    }
    
    const onSelectStaff = (value, action) => {
        // eslint-disable-next-line default-case
        switch (action) {
            case constants.GROUP.VIEW: {
                setSelectedGroup(value)
                setViewGroupModal(true)
                break;
            }
            case constants.GROUP.QR: {
                setSelectedGroup(value)
                setQrGroupModal(true)
                break;
            }
            case constants.GROUP.DELETE: {
                setSelectedGroup(value)
                setConfirmationMessage(`Are you sure want to cancel group <b>${value.name}</b> submission?`)
                setIsConfirmModalOpen(true)
                break;
            }
        }
    }
    const onConfirm = (record) => {
        deleteGroup(record.groupId)
        setIsConfirmModalOpen(false)
    }
    const onNotConfirm = () => {
        setIsConfirmModalOpen(false)
    }
    const filterGroup = () => {
        setNetworkCall(true);
        ApiService.FILTER_GROUP_LIST(filter, user.token.token).then(res=>{
            setRecords(res?.payload?.records.map(item=>{
                return {
                    groupId: item.groupId,
                    groupName: item.groupName,
                    groupSlug: item.groupSlug,
                    restaurants: item.restaurants,
                    totalRestaurants: item.totalRestaurants,
                }
            }))
            setTotalGroup(res?.payload?.pagination?.total)
            setCurrentPage(res?.payload?.pagination?.page)
            setNetworkCall(false);
        })
    }
    const addGroup = (params) => {
        ApiService.ADD_GROUP(params, user.token.token).then(res=>{
            setIsModalOpen(false)
            if(res.code===200){
                setSearchText("")
                setIsModalOpen(false)
                showNotification('Group added', false)
                setFilter({...filter, sortBy: 'NEWEST', page: 1, searchText: ''})
            }
            else {
                showNotification(res.data.message)
            }
        })
    }
    const deleteGroup = (params) => {
        ApiService.DELETE_GROUP(params, user.token.token).then(res=>{
            setIsModalOpen(false)
            if(res.code===200){
                setSearchText("")
                setIsModalOpen(false)
                showNotification("Group deleted.", false)
                setFilter({...filter, sortBy: 'NEWEST', page: 1, searchText: ''})
            }
            else {
                showNotification(res.data.message)
            }
        })
    }
    const onPageChange = (pageNumber) => {
        setCurrentPage(pageNumber)
        setFilter({...filter, page: pageNumber})
    }
    
    useEffect(()=>{
        setNetworkCall(true);
        setFilter({...filter, restaurantSlug, sortBy: "NEWEST"})
    },[])

    useEffect(()=>{
        if(!firstTime){
            filterGroup()
        }
        else {
         setFirstTime(false)
        }
    },[filter])

    return (
        <div className="flex flex-col bg-[#e5e7eb]">
            <CustomLoader/>
            <Header title={""} menu={constants.SUPER_MENU.GROUP} currentMenuKey={'T_53_S_53'}/>
            <div className="flex flex-row bg-prewhite">
                <SideMenu title={`McDonalds Food Chain`} menu={constants.SUPER_MENU.GROUP}/>
                <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
                    <div className="flex flex-col w-full">
                        <TableHeaderComponent
                            searchText={searchText}
                            setSearchText={setSearchText}
                            sortingOptions={sortingOptions1}
                            onChangeSorting={onSortRecord}
                            record={
                                {
                                    title: 'All Group',
                                    hint: 'Search in group',
                                    callback: onClickAddButton,
                                    search: onSearchText,
                                }
                            }
                        />
                        <div className="flex flex-col">
                            {records?.map((item, index)=>{
                                return (
                                    <div key={`cat${index}`}>
                                        <GroupItemComponent
                                            record={item}
                                            callback={onSelectStaff}
                                        />
                                    </div>)
                            })}
                        </div>
                        {!networkCall && records.length === 0 && <DataNotFound />}
                        <div className="flex flex-row justify-start font-uregular">
                            <ConfigProvider theme={{
                                components: {
                                    Pagination: {
                                        itemActiveBg: '#FFD700',
                                        fontFamily: 'ubold',
                                        colorPrimaryBorder: '#FFD700',
                                        colorPrimary: '#111111',
                                        colorPrimaryHover: '#111111',
                                        itemInputBg: '#111111',
                                        itemBg: '#E5E4E9'
                                    }
                                }
                            }}>
                                <Pagination
                                    total={totalGroup}
                                    showTotal={(total) => `Total ${total} items`}
                                    defaultPageSize={perPage}
                                    defaultCurrent={currentPage}
                                    current={currentPage}
                                    onChange={onPageChange}
                                    showSizeChanger={false}
                                />
                            </ConfigProvider>
                        </div>
                    </div>
                    <AddGroupModal
                        openModal={isModalOpen}
                        records={
                            {
                                onFinish: onClickSaveButtonInModal,
                                onCancel: onClickCancelButtonInModal
                            }
                        }
                    />
                    <ViewGroupModal
                        openModal={viewGroupModal}
                        records={
                            {
                                onFinish: onClickSaveButtonInModal,
                                onCancel: onClickViewGroupModal,
                                param: selectedGroup
                            }
                        }
                    />
                    <QrGroupModal 
                        openModal={qrGroupModal}
                        record={
                            {
                                onFinish: onClickQrGroupModal,
                                onCancel: onClickQrGroupModal,
                                param: selectedGroup
                            }
                        }
                    />
                    <ConfirmationModal 
                        openModal={isConfirmModalOpen} 
                        records={
                            {
                                onFinish: onConfirm,
                                onCancel: onNotConfirm,
                                message: confirmationMessage,
                                param: selectedGroup
                            }
                        }
                    />
                </div>
            </div>
        </div>
    );
}

export default Group;
